// extracted by mini-css-extract-plugin
export var bContent = "Example-module--bContent--ba065";
export var root = "Example-module--root--ebf7f";
export var tagC = "Example-module--tagC--3f66a";
export var tagsC = "Example-module--tagsC--70c10";